import { QueryHookOptions, useQuery } from '@apollo/client';
import getPlatformAccountsQuery from './managedPlatformAccountsQuery.graphql';

export const useManagedPlatformAccountsQuery = (
  options: QueryHookOptions<
    ManagedPlatformAccountsQuery,
    QueryManagedPlatformAccountsArgs
  >,
) => {
  return useQuery<
    ManagedPlatformAccountsQuery,
    QueryManagedPlatformAccountsArgs
  >(getPlatformAccountsQuery, options);
};
